"use client";

import dynamic from "next/dynamic";

// Lazy mount for the SEO-surface free web-push capture (2026-07-21). It was born
// dark behind NEXT_PUBLIC_SEO_SURFACE_PUSH_CAPTURE_ENABLED; production built it as
// "1" and the flag was removed on 2026-11-03.
//
// It loads the slide-in client-side only (ssr:false, loading:null), so the
// capture never renders on the server and never enters the indexable HTML.
// This wrapper is the single place every SEO surface mounts the capture, so there
// is exactly one instance per surface (rule 67 — pinned by the one-instance test).

const SeoSurfacePushCapture = dynamic(() => import("./SeoSurfacePushCapture"), {
  ssr: false,
  loading: () => null,
});

export default function SeoSurfacePushCaptureMount({
  surface,
  lang = "hi",
  trigger,
}: {
  surface: string;
  lang?: "en" | "hi";
  /**
   * `"value_moment"` on surfaces that produce a result (the ask waits for it);
   * omit on content hubs, which have no result to wait for.
   */
  trigger?: "engagement" | "value_moment";
}) {
  return <SeoSurfacePushCapture surface={surface} lang={lang} trigger={trigger} />;
}
